(function() {
	"use strict";

	angular.module( "ATMGurus" )


	/**
	*
	*	SORRY If you're maintaining this
	*	i swear once i knew how to properly use jQuery :/
	*
	*
	*/

	.directive( "atmgTable", [
		"$sce",
		function( $sce ) {
			return {
				type: "AE",
				scope: {
					content: '@',
					header: '@'
				},
				link: function( scope, element, attrs) {
					var table = $( scope.content ),
						row = 0,
						columnsCount = undefined;

					var output = $( '<table class="table-stripes b1"></table' );
					var tbody = $( '<tbody></tbody>' );
					var thead = $( '<thead></thead>' );

					var title = $( '<tr></tr>' );

					_( $( table ).find('tbody').children( 'tr' ) ).each( function ( tr, rownr ) {

						var row = $( '<tr></tr>' );
						columnsCount = $( tr ).find( 'td' ).length;

						_( $( tr ).find( 'td' ) ).each( function( td ) {

							$( td ).addClass( 'table-cell ps bt1' );

							if ( rownr === 0 ) {
								$(td).addClass( 'bg-primary color-white' );
							}

							row.append( td );
						})

						if ( rownr === 0 ){
							thead.append( $("<tr><td class='table-cell p1 bg-tertiary' colspan='" + columnsCount + "'><h2 class='h4 color-white mn'>" + scope.header + "</h2></td></tr>") )
							thead.append( row)
							tbody.append( thead )
						}
						else {
							tbody.append( row )
						}

					})

					output.append( thead );
					output.append( tbody );

					element.html( output )
				}
			}
		}
	])

})()


// WEBPACK FOOTER //
// ./src/app/directives/atmg-table.js